import React from "react";
import { useNavigate } from "react-router-dom";
import productImage from "./WhatsApp Image 2025-12-22 at 11.27.57 PM (1) (1).png";
import "./App.css";

function Cart({ cart = [], addToCart, removeFromCart, clearCart }) {
  const navigate = useNavigate();

  // Group cart items by id to display quantity
  const groupedCart = cart.reduce((acc, item) => {
    const existing = acc.find((grouped) => grouped.id === item.id);
    if (existing) {
      existing.qty += 1;
      existing.totalPrice += item.price;
    } else {
      acc.push({ ...item, qty: 1, totalPrice: item.price });
    }
    return acc;
  }, []);

  const totalPrice = cart.reduce(
    (total, item) => total + item.price,
    0
  );

  const placeOrder = () => {
    let msg = "🛒 *New Order from your website*%0A%0A";

    cart.forEach((item, i) => {
      msg += `${i + 1}. ${item.name} - ₹${item.price}%0A`;
    });

    msg += `%0A💰 *Total:* ₹${totalPrice}`;

    const phone = "917863883934";
    window.location.href = `https://wa.me/${phone}?text=${msg}`;
  };

  return (
    <>
      <head>
        <title>OM AGRO FOODS | Premium Kesar Mango Pulp Manufacturer & Supplier</title>

        <meta
          name="description"
          content="OM AGRO FOODS offers premium quality Kesar Mango Pulp made from handpicked mangoes. Ideal for aamras, ice creams, desserts, beverages, and bulk supply."
        />

        <meta
          name="keywords"
          content="buy product of om agro foods,buy best mango pulp, mango price, mango pulp per kg price, mango pulp price, best mango pulp Manufacturer, buy natural mango pulp, Kesar Mango Pulp, Mango Pulp Manufacturer, Mango Pulp Supplier, OM AGRO FOODS, om agro foods , natural mango pulp, mango pulp, Aamras Pulp, Bulk Mango Pulp"
        />

        <link rel="canonical" href="https://omagrofoods.vercel.app/" />

        <link rel="icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" sizes="48x48" />
        <link rel="icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" sizes="96x96" />
        <link rel="icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" sizes="192x192" />
        <link rel="shortcut icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" />
        <link rel="apple-touch-icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" />
        <meta property="og:title" content="OM AGRO FOOD | Premium Kesar Mango Pulp" />
        <meta
          property="og:description"
          content="Premium quality Kesar Mango Pulp with rich taste, aroma, and natural sweetness. Available for retail and bulk orders."
        />
        <meta property="og:image" content={productImage} />
        <meta property="og:url" content="https://omagrofoods.vercel.app/" />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="OM AGRO FOODS | Premium Mango Pulp" />
        <meta
          name="twitter:description"
          content="Premium Kesar Mango Pulp supplier for homes, hotels, and food industries."
        />
        <meta name="twitter:image" content={productImage} />
      </head>
    <div className="cart-page">
      <h2>🛒 Your Cart</h2>

      {cart.length === 0 && (
        <div className="empty-cart">
          <p>No items in cart</p>

          <button
            className="add-cart-btn"
            onClick={() => navigate("/mango-pulp")}
          >
            ➕ Add item in cart
          </button>
        </div>
      )}

      {groupedCart.map((item, index) => (
        <div className="cart-item" key={item.id}>
          <span>{item.name}</span>
          <span>₹{item.price * item.qty}</span>

          <div className="qty-control">
            <button
              className="qty-btn"
              onClick={() => removeFromCart(item.id)}
            >
              −
            </button>
            <span className="qty-count">{item.qty}</span>
            <button
              className="qty-btn"
              onClick={() => addToCart(item)}
            >
              +
            </button>
          </div>
        </div>
      ))}

      {cart.length > 0 && (
        <>
          <h3>Total: ₹{totalPrice}</h3>

          <button className="order-btn" onClick={placeOrder}>
            📲 Order on WhatsApp
          </button>

          <button className="clear-cart-btn" onClick={clearCart}>
            🗑️ Clear Cart
          </button>

          <button className="shop-more-btn" onClick={() => navigate("/mango-pulp")}>
            ➕ Add item in cart
          </button>
        </>
      )}
    </div>
    </>
  );
}

export default Cart;
